import dayjs from "dayjs";
import hotelInfoTypes from "../actionType/hotelInfoTypes";

const initialState = {
  hotelData: {},
  fetching: true,
  selectedRooms: [],
  selectedAddons: [],
  selectedRatePlans: [],
  selectedHotelAddons: [],
  rating: 3.9,
  review: [],
  totalPeople: 2,
  totalAdult: 2,
  totalChild: 0,
  totalInfant: 0,
  dateRange: {},
  // Stay dates the loaded room prices were fetched for. dateRange changes as
  // soon as the guest picks dates; this only changes when a search lands.
  pricedDates: null,
  dateCount: 1,
  pendingReasons: [],
  instaLinks: [],
  isRatePlans: false,
  promotions: [],
  paymentMethodPromotions: [],
  faqs: [],
  policies: [],
  payments: [],
  reviews: [],
  reviews_Arjun: [],

  showHourly: false,
  hourlyDate: dayjs(),
  isHourlyRoom: false,
  roomSlots: {},
  hourlyTime: dayjs()
    .add(1, "hour")
    .set("minute", 0)
    .set("second", 0)
    .set("millisecond", 0)
    .format("hh:mm A"),
  hourlyHour: null,
  livePricing: [],
  taxes: [],
  updatedRoomCount: {},
  couponCode: {},
  couponName: "",
  maharajaId: null,
  maharajaIdError: false,
  gstin: null,
  paymentProvider: {},
  scriptTagId: null,
  Retargeting: false,
  notifyNoInventory: false,
  CalendarPrices: {},
  hotel_videos: [],
  isSignup: false, //for anayabeacon
  isContinueBooking: false,
  showMembershipModal: false,
  selectedPackage: null,
  availablePackages: [],
  bookingEngineConfig: null,
  bookingEngineConfigLoading: false,
  nearbyHotels: [],
  isReturningMember: false,
  selectedPaymentOffer: null,
};

// Every room of the same room + rate plan shares one `id`; `idx` tells them
// apart. Without an idx, the last-added room of that id is the target.
const findRatePlanIndex = (rps = [], { id, idx } = {}) => {
  for (let i = rps.length - 1; i >= 0; i--) {
    if (
      rps[i]?.id === id &&
      (idx === undefined || idx === null || String(rps[i]?.idx) === String(idx))
    ) {
      return i;
    }
  }
  return -1;
};

const removeOneRatePlan = (rps = [], target) => {
  const at = findRatePlanIndex(rps, target);
  if (at === -1) return [...rps];
  return [...rps.slice(0, at), ...rps.slice(at + 1)];
};

export const hotelInfoReducer = (
  state = { ...initialState },
  { type, payload }
) => {
  switch (type) {
    case hotelInfoTypes.FETCHING: {
      return { ...state, fetching: payload };
    }

    case hotelInfoTypes.SET_SLOTS: {
      return { ...state, roomSlots: payload };
    }
    case hotelInfoTypes.SET_HOUR: {
      return { ...state, hourlyHour: payload };
    }

    case hotelInfoTypes.FETCH_REVIEW: {
      return { ...state, reviews: payload || [] };
    }

    case hotelInfoTypes.FETCH_REVIEW_Arjun: {
      return { ...state, reviews_Arjun: payload || [] };
    }

    case hotelInfoTypes.SHOW_HOURLY: {
      return { ...state, showHourly: payload };
    }

    case hotelInfoTypes.SET_HOURLY_TIME: {
      return { ...state, hourlyTime: payload };
    }

    case hotelInfoTypes.SET_SHOW_HOURLY: {
      return { ...state, isHourlyRoom: payload };
    }

    case hotelInfoTypes.DETAILS: {
      return { ...state, hotelData: payload, updatedRoomCount: {} };
    }

    case hotelInfoTypes.SET_IS_RATEPLAN: {
      return { ...state, isRatePlans: payload };
    }

    case hotelInfoTypes.SET_PAYMENT_PROVIDER: {
      return { ...state, paymentProvider: payload };
    }

    case hotelInfoTypes.SELECT_ROOM: {
      var arr = [];
      arr.push(payload);

      return { ...state, selectedRooms: [...state.selectedRooms, ...arr] };
    }

    case hotelInfoTypes.SELECT_RP: {
      let arr = [];
      arr.push(payload);
      return {
        ...state,
        selectedRatePlans: [...state.selectedRatePlans, ...arr],
      };
    }

    case hotelInfoTypes.REMOVE_RP: {
      // { id, idx } removes that one room; a bare id removes every room of
      // that room + rate plan.
      const filteredRps =
        payload && typeof payload === "object"
          ? removeOneRatePlan(state?.selectedRatePlans, payload)
          : state?.selectedRatePlans?.filter((rp) => rp?.id !== payload);
      return {
        ...state,
        selectedRatePlans: [...filteredRps],
      };
    }

    case hotelInfoTypes.UPDATE_RP: {
      // Swaps one selected room (rmRpId + rmIdx) for newRp in place, keeping
      // its position in the cart and every other room untouched.
      const { obj: newRp, rmRpId, rmIdx } = payload;
      const rps = [...(state?.selectedRatePlans || [])];
      const at = findRatePlanIndex(rps, { id: rmRpId, idx: rmIdx });
      if (at === -1) {
        rps.push(newRp);
      } else {
        rps.splice(at, 1, newRp);
      }
      return {
        ...state,
        selectedRatePlans: rps,
      };
    }

    case hotelInfoTypes.DESELECT_RP: {
      // { id, idx } removes that exact room (e.g. the booking summary's x);
      // a bare id removes the most recently added room of that room + rate
      // plan, so the room-card "-" never drops a room the guest customised
      // earlier.
      return {
        ...state,
        selectedRatePlans: removeOneRatePlan(
          state.selectedRatePlans,
          payload && typeof payload === "object" ? payload : { id: payload }
        ),
      };
    }

    case hotelInfoTypes.EDIT_RP: {
      let arr = [...state.selectedRatePlans];
      let updatedArr = arr.map((rp) => {
        if (rp?.id === payload?.id && rp?.idx === payload?.idx) {
          return { ...rp, ...payload };
        }
        return rp;
      });
      return { ...state, selectedRatePlans: [...updatedArr] };
    }

    case hotelInfoTypes.SET_TAXES: {
      return { ...state, taxes: [...payload] };
    }

    case hotelInfoTypes.RESET_RP: {
      let rpArr = [...state.selectedRatePlans];
      let newArr = rpArr.filter((rm) => rm?.id !== payload?.id);
      return {
        ...state,
        selectedRatePlans: [...newArr],
      };
    }
    case hotelInfoTypes.SET_COUPON_CODE: {
      const { PromotionsExtraConfigs = [] } = payload;
      const codes =
        PromotionsExtraConfigs?.filter(
          (pr) => pr?.type === "coupon_code"
        )?.[0] || {};
      let name = codes?.value?.[0] || "";
      return {
        ...state,
        couponCode: payload,
        couponName: name,
      };
    }

    case hotelInfoTypes.SET_MAHARAJA_ID: {
      return { ...state, maharajaId: payload, maharajaIdError: false };
    }

    case hotelInfoTypes.SET_MAHARAJA_ID_ERROR: {
      return { ...state, maharajaIdError: payload };
    }

    case hotelInfoTypes.SET_GSTIN: {
      return { ...state, gstin: payload };
    }

    case hotelInfoTypes.RESET_ROOM: {
      let roomArr = [...state.selectedRooms];
      let adnArr = [...state.selectedAddons];
      let newArr = roomArr.filter((rm) => rm?.id !== payload?.id);
      let newAdnArray = adnArr.filter((rm) => rm?.hotelRoomId !== payload?.id);
      if (payload?.resetAdn) {
        return {
          ...state,
          selectedRooms: [...newArr],
          selectedAddons: [...newAdnArray],
        };
      }
      return {
        ...state,
        selectedRooms: [...newArr],
      };
    }

    case hotelInfoTypes.SET_ROOM: {
      let roomsArr = [...state.selectedRooms];

      let newArr =
        roomsArr.filter(
          (rm) => rm?.id !== payload?.id || rm?.idx !== payload?.idx
        ) || [];

      newArr = [...newArr, payload];
      return { ...state, selectedRooms: newArr };
    }

    case hotelInfoTypes.DESET_ROOM: {
      const newArr = [...payload];
      return { ...state, selectedRooms: newArr };
    }

    case hotelInfoTypes.DESELECT_ROOM: {
      // Copy - splicing state.selectedRooms in place kept the same array
      // reference, so hooks keyed on it never re-ran.
      let arr = [...(state.selectedRooms || [])];

      // The exact room when the payload carries an idx, otherwise the most
      // recently added room of that id (keeps earlier customised rooms).
      let at = -1;
      for (let i = arr.length - 1; i >= 0; i--) {
        if (
          arr[i]?.id === payload?.id &&
          (payload?.idx === undefined || arr[i]?.idx === payload?.idx)
        ) {
          at = i;
          break;
        }
      }
      if (at === -1) {
        for (let i = arr.length - 1; i >= 0; i--) {
          if (arr[i]?.id === payload?.id) {
            at = i;
            break;
          }
        }
      }
      if (at !== -1) arr.splice(at, 1);
      let roomSelected = arr?.some((rm) => rm?.id === payload?.id);

      let roomAddons = state.selectedAddons.filter(
        (adn) => adn?.hotelRoomId !== payload.id
      );

      if (!roomSelected) {
        return {
          ...state,
          selectedRooms: arr,
          selectedAddons: [...roomAddons],
        };
      }

      if (arr.length === 0)
        return { ...state, selectedRooms: arr, selectedAddons: [] };
      return { ...state, selectedRooms: [...arr] };
    }

    case hotelInfoTypes.SELECT_ADDON: {
      let arr = [];
      arr.push(payload);
      return { ...state, selectedAddons: [...state.selectedAddons, ...arr] };
    }

    case hotelInfoTypes.SET_HOURLY_DATE: {
      return { ...state, hourlyDate: payload };
    }

    case hotelInfoTypes.DESELECT_ADDON: {
      const arr = state.selectedAddons;
      for (let i = 0; i < arr.length; i++) {
        if (payload?.Addon?.category === "person") {
          if (
            parseFloat(arr[i].price) === parseFloat(payload.price) &&
            arr[i].hotelRoomId === payload.hotelRoomId
          ) {
            arr.splice(i, 1);
            break;
          }
        } else if (arr[i].id === payload.id) {
          arr.splice(i, 1);
          break;
        }
      }
      return { ...state, selectedAddons: [...arr] };
    }

    case hotelInfoTypes.ADD_HOTELADDON: {
      let arr = [];
      arr.push(payload);
      return {
        ...state,
        selectedHotelAddons: [...state.selectedHotelAddons, ...arr],
      };
    }

    case hotelInfoTypes.REMOVE_HOTELADDON: {
      const arr = [...state.selectedHotelAddons];

      for (let i = 0; i < arr.length; i++) {
        if (arr[i].id === payload.id) {
          arr.splice(i, 1);
          break;
        }
      }
      return { ...state, selectedHotelAddons: [...arr] };
    }

    case hotelInfoTypes.TOTAL_PEOPLE: {
      return { ...state, totalPeople: payload };
    }

    case hotelInfoTypes.EMPTY_ROOM: {
      return { ...state, selectedRooms: [] };
    }

    case hotelInfoTypes.TOTAL_ADULT: {
      return { ...state, totalAdult: payload };
    }

    case hotelInfoTypes.TOTAL_CHILD: {
      return { ...state, totalChild: payload };
    }

    case hotelInfoTypes.TOTAL_INFANT: {
      return { ...state, totalInfant: payload };
    }

    case hotelInfoTypes.SET_DATE: {
      return { ...state, dateRange: payload };
    }

    case hotelInfoTypes.DATE_COUNT: {
      return { ...state, dateCount: payload };
    }

    case hotelInfoTypes.RESET: {
      return {
        ...state,
        selectedRooms: [],
        selectedAddons: [],
        selectedHotelAddons: [],
        selectedRatePlans: [],
        updatedRoomCount: {},
        couponCode: {},
        maharajaId: null,
        maharajaIdError: false,
        gstin: null,
      };
    }

    case hotelInfoTypes.ADD_RATING: {
      return { ...state, rating: payload };
    }

    case hotelInfoTypes.ADD_REVIEW: {
      return { ...state, review: payload };
    }

    case hotelInfoTypes.PENDING_REASONS: {
      return { ...state, pendingReasons: payload };
    }

    case hotelInfoTypes.SET_INSTA_LINKS: {
      return { ...state, instaLinks: payload };
    }

    case hotelInfoTypes.SET_PROMOTION: {
      return { ...state, promotions: payload };
    }

    case hotelInfoTypes.GET_FAQ: {
      return { ...state, faqs: payload };
    }

    case hotelInfoTypes.GET_POLICY: {
      return { ...state, policies: payload };
    }

    case hotelInfoTypes.SET_OWNER_DETAILS: {
      return { ...state, ownerDetails: payload };
    }

    case hotelInfoTypes.SET_PAYMENTS: {
      return { ...state, payments: payload };
    }

    case hotelInfoTypes.SET_LIVE_PRICE: {
      return { ...state, livePricing: payload };
    }

    case hotelInfoTypes.SET_UPDATED_ROOM_COUNT: {
      let obj = {
        ...state.updatedRoomCount,
        [payload?.id]: payload?.value,
      };
      return {
        ...state,
        updatedRoomCount: obj,
      };
    }

    case hotelInfoTypes.BNPL_CONFIG: {
      return { ...state, bnplConfig: { ...state.bnplConfig, ...payload } };
    }

    case hotelInfoTypes.GET_SCRIPT_TAG_ID: {
      return { ...state, scriptTagId: payload };
    }

    case hotelInfoTypes.SET_RETARGETING: {
      return { ...state, Retargeting: payload };
    }

    case hotelInfoTypes.SET_NOTIFY_NO_INVENTORY: {
      return { ...state, notifyNoInventory: payload };
    }

    case "SET_SELECTED_PACKAGE": {
      return {
        ...state,
        selectedPackage: payload.package,
        selectedRatePlans: payload.selectedRatePlans,
      };
    }

    case "SET_AVAILABLE_PACKAGES": {
      return { ...state, availablePackages: payload };
    }

    case "CLEAR_SELECTED_PACKAGE": {
      return { ...state, selectedPackage: null };
    }

    case hotelInfoTypes.RESET_SELECTED_RATEPLANS: {
      return { ...state, selectedRatePlans: [] };
    }

    case hotelInfoTypes.SET_PRICED_DATES: {
      return { ...state, pricedDates: payload };
    }

    case hotelInfoTypes.CALENDAR_PRICE_DISPLAY: {
      const [month, data] = Object.entries(payload)[0];
      return {
        ...state,
        CalendarPrices: {
          ...state.CalendarPrices,
          [month]: data,
        },
      };
    }

    //for anayabeacon
    case hotelInfoTypes.SET_SIGN_UP: {
      return { ...state, isSignup: payload };
    }

    case hotelInfoTypes.SET_HOTELVIDEOS: {
      return { ...state, hotel_videos: payload || [] };
    }

    case hotelInfoTypes.SET_FULL_STATE: {
      return { ...state, ...payload };
    }

    case hotelInfoTypes.SET_CONTINUE_BOOKING: {
      return { ...state, isContinueBooking: payload };
    }

    case hotelInfoTypes.SET_UPSELL: {
      return { ...state, upsell: payload };
    }

    case hotelInfoTypes.SHOW_MEMBERSHIP_MODAL: {
      return { ...state, showMembershipModal: payload };
    }

    case hotelInfoTypes.SET_BOOKING_ENGINE_CONFIG: {
      return { ...state, bookingEngineConfig: payload };
    }

    case hotelInfoTypes.SET_BOOKING_ENGINE_CONFIG_LOADING: {
      return { ...state, bookingEngineConfigLoading: payload };
    }

    case hotelInfoTypes.SET_NEARBY_HOTELS: {
      return { ...state, nearbyHotels: payload };
    }

    case hotelInfoTypes.SET_RETURNING_MEMBER: {
      return { ...state, isReturningMember: payload };
    }

    case hotelInfoTypes.SET_PAYMENT_METHOD_OFFER: {
      return { ...state, selectedPaymentOffer: payload ?? null };
    }

    case hotelInfoTypes.SET_PAYMENT_METHOD_PROMOTIONS: {
      return { ...state, paymentMethodPromotions: payload ?? [] };
    }

    default: {
      return { ...state };
    }
  }
};
